import {memo, useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import cn from 'clsx'
// import {useParams} from 'react-router-dom'
import { Divider, /* Input */ } from 'antd'
import cardStyles from './AboutCard.variation.module.scss'
import styles from './RequestForecast.module.scss'
import useStore from 'base/store'
import { PermissionType } from 'common/types'
import {useInputFocus} from 'common/hooks'
import {
  Block,
  Text,
  Modal,
  Button, IconButton,
  DotsIcon,
  Form, useForm, FormItem, InputPercent //InputAmount, 
} from 'common/components'
// import {useGetForecast} from 'common/api'
import { isEqual } from 'common/helpers'
import {FIELD_RULES} from 'common/constants'
import {VariationScheduleList} from '..'
import {useGetVariationRequest, useGetVariationSchedule, useSaveVariationLineFee, useCalcVariationLineFee} from '../api.variation'
// import { SCHEDULE_DATA_LINE_FEE } from './VariationScheduleList.mock'
import {isSameTerm, isReduceAmount} from 'modules/project/components/VariationForm.helper'
import { 
  formatMoney,
  cbFilterSchedule, cbFilterJournal, cbMap2Schedule, cbMap2Journal 
} from '../schedule.helper'

// const { TextArea } = Input

interface FormProps {
  isDuringConfirm: boolean
  isConfirm: boolean
  balance: number
  lineFeeRate: number
  request: any
  onClose: () => void
}

interface CardProps {
  journalIncluded?: boolean
  lineFeeRate:number
  balance: number
  request: any
  onModalOpen?: () => void
}

const isSpecial = (type:string) =>  ( isSameTerm(type) && isReduceAmount(type) )

export default function VariationRequestLineFee({
  isDuringConfirm, isConfirm, showCard
}:{
  isDuringConfirm?: boolean     // it is during the 2nd round right now
  isConfirm?: boolean           // this component is for the 2nd round tasks
  showCard?: boolean
}) {
  const params = useParams()
  const {data:request} = useGetVariationRequest(params.uuid)
  const {data} = useGetVariationSchedule(params.uuid, 'lineFee')

  const modalOpenKey = useStore((state) => state.variationLineFeeOpenKey)
  const setModalOpenKey = useStore((state) => state.setVariationLineFeeOpenKey)
  const handleModalOpen = () => setModalOpenKey(!isConfirm ? '1st':'2nd')
  const handleModalClose = () => setModalOpenKey(null)

  const {lineFeeRate, balance} = data || {}
  const scheduleItems = data?.scheduleItems?.filter(
    cbFilterSchedule
  ).map(cbMap2Schedule) || []
  // const journalItems: any[] = []
  const journalItems = data?.scheduleItems?.filter(
    cbFilterJournal
  ).map(cbMap2Journal) || []

  return (
    <>
      { !!showCard &&
      <Block relative type="white">
        <Card
          journalIncluded={!!journalItems?.length}
          lineFeeRate={lineFeeRate}
          balance={balance}
          request={request}
          onModalOpen={handleModalOpen}
        />
      </Block>
      }
      <Modal
        // title={`Variation Forecast`}
        width={1392}
        open={modalOpenKey === (!isConfirm ? '1st':'2nd') }
        onCancel={handleModalClose}
      >
        <Text mt={48} mb={16} size="2xl" weight="bold" color="black">Line fee</Text>
        <Divider />
        <Text mb={60} size="md" color="black">
          The system has generated the schedule for line fee calculation as follows. If needed, you can make a journal entry to adjust the balance based on the contract.
        </Text>
        <VariationScheduleList
          permissionRequired={'edit variation line fee'}
          statusRequired={ !isConfirm ? 'lending-manager-check':'ready-to-open'}
          title="Schedule for line fee calculation" 
          exTitle="line-fee"
          request={request}
          data={[
            // ...SCHEDULE_DATA_ESTABLISHMENT_FEE,
            ...scheduleItems,
          ]}
          journal={[
            // ...SCHEDULE_DATA_JOURNAL_INPUT
            ...journalItems
          ]} 
        />
        <Divider />
        <ConfirmForm
          isDuringConfirm={isDuringConfirm}
          isConfirm={isConfirm}
          lineFeeRate={lineFeeRate}
          balance={balance}
          request={request}
          onClose={handleModalClose}
        />
      </Modal>
    </>
  )
}

const Card = memo(
  ({journalIncluded, lineFeeRate, balance, request, onModalOpen}: CardProps) => {
    const [calcResult, setCalcResult] = useState<any>(null)
    const dealResult = (data:any) => {
      // console.log('result back', data)
      if (!!data) setCalcResult(data)
      else setCalcResult(null)
    }
    const {mutate: calculate} = useCalcVariationLineFee(request.uuid, dealResult)

    // console.log(lineFeeRate, request)

    useEffect(() => {
      calculate({ balance, lineFeeRate })
    }, [balance, lineFeeRate, calculate])
  
    const first = calcResult?.firstLineFee || {}
    const last  = calcResult?.lastLineFee || {}

    return (
      <>
        { !!onModalOpen &&
          <IconButton className={styles.edit} onClick={onModalOpen}>
            <DotsIcon />
          </IconButton>
        }

        <div className={cardStyles.root}>

          <Text size="md" weight="demiBold" color="black" mb={16}>
            Line fee
          </Text>
          { (isSpecial(request?.type)) ?
            <Text size="xs" color="black" >
              The line fee remains the same as the original.
            </Text>
            :
            <>
            { (!!journalIncluded) &&
              <Text size="xs" color="black" mb={10}>
                *Credit journal entry has been added to the schedule.
              </Text>
            }
            <div className={cardStyles['grid-columns-3']}>
              <div>
                <Text mb={4} color="grayer" size="xs">Monthly line fee</Text>
                <Text mb={16} color="black" size="md" weight="demiBold">{formatMoney(calcResult?.monthlyLineFee ?? 0)}</Text>
              </div>
              <div>
                <Text mb={4} color="grayer" size="xs">Line fee rate(M)</Text>
                <Text mb={16} color="black" size="md" weight="demiBold">{lineFeeRate}%</Text>
              </div>
            </div>

            <Text mb={4} color="grayer" size="xs">The first line fee</Text>
            <div className={cardStyles['flex-between']}>
              <Text mb={16} color="black" size="md" weight="demiBold">{formatMoney(first.value ?? 0)}</Text>
              <Text mb={16} color="black" size="md" >{first.notes || ''}</Text>
            </div>

            <Text mb={4} color="grayer" size="xs">The last line fee</Text>
            <div className={cardStyles['flex-between']}>
              <Text color="black" size="md" weight="demiBold">{formatMoney(last.value ?? 0)}</Text>
              <Text mb={16} color="black" size="md">{last.notes || ''}</Text>
            </div>
            </>
          }
        </div>
      </>
    )
  },
  (prevProps, nextProps) => isEqual(prevProps, nextProps)
)

const ConfirmForm = ({balance, lineFeeRate, request, isConfirm, isDuringConfirm, onClose}:FormProps) => {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  const [calcResult, setCalcResult] = useState<any>(null)
  const dealResult = (data:any) => {
    // console.log('result back', data)
    if (!!data) setCalcResult(data)
    else setCalcResult(null)
  }

  const {mutate: saveLineFee} = useSaveVariationLineFee(request.uuid, onClose)
  const {mutate: calculate} = useCalcVariationLineFee(request.uuid, dealResult)
  const [form] = useForm()
  const inputRef = useInputFocus()

  const special = isSpecial(request?.type)

  const handleFinish = (values: any) => {
    if (special) {
      saveLineFee({})
      return
    }
    // else
    const payload = {
      lineFeeRate: values.lineFeeRate,
      monthlyLineFee: calcResult?.monthlyLineFee ?? 0
    }
    saveLineFee(payload)
  }
  const handleFieldsChange = (values: any) => {
    // console.log('change', values)
    calculate({
      balance,
      lineFeeRate: values.lineFeeRate
    })
    // if (!('lineFeeRate' in values)) return
    // form.resetFields(['date', 'amount'])
  }
  useEffect(() => {
    calculate({ balance, lineFeeRate })
  }, [balance, lineFeeRate, calculate])

  const initialValues: any = {
    lineFeeRate
  }

  const statusRequired= !isConfirm ? 'lending-manager-check':'ready-to-open'
  const isNotAllowed = (statusRequired !== request?.status) || (!permissions?.includes('edit variation line fee'))
  const disableInput = (!isConfirm && !!isDuringConfirm) || !!isNotAllowed
  // console.log(calcResult)
  return (
    <>
      <Text mt={52} mb={40} size="lg" color='black' weight="bold">Line fee</Text>
      { special &&
        <Text mb={40} color='black' >
          For the "same term, reduce loan amount" scenario, the line fee remains the same as the original.
        </Text>
      }
      <Form className={styles['confirm-form']}
        initialValues={initialValues}
        form={form}
        validateTrigger="onChange"
        onValuesChange={handleFieldsChange}
        onFinish={handleFinish}
      >
        <div className={styles['grid-columns-3']} style={special ? {display: 'none'} : {}}>
          <div>
            <Text mb={6} size="xs" color="grayer">Balance</Text>
            <div style={{height: '48px', display: 'flex', alignItems: 'center'}}>
              <Text size="md" color="black" weight="medium">
                {formatMoney(balance)}
              </Text>
            </div>
          </div>
          <div style={{width: '96px'}}>
            <FormItem name="lineFeeRate" label="Line fee rate (M)" rules={FIELD_RULES}>
              <InputPercent ref={inputRef} disabled={!!isConfirm || disableInput} />
            </FormItem>
          </div>
        </div>
        { !!calcResult?.monthlyLineFee && !special &&
          <div className={styles['grid-columns-3']}>
            <Text size="md">Monthly line fee</Text>
            <Text size="md" weight="demiBold">{formatMoney(calcResult.monthlyLineFee || 0)}</Text>
          </div>
        }
        { !!calcResult?.firstLineFee && !special &&
          <div className={styles['grid-columns-3']}>
            <Text size="md">The first line fee</Text>
            <Text size="md" weight="demiBold">{formatMoney(calcResult.firstLineFee.value || 0)}</Text>
            <Text size="md">{calcResult.firstLineFee.notes}</Text>
          </div>
        }
        { !!calcResult?.lastLineFee && !special &&
          <div className={cn(styles['grid-columns-3'], styles['grid-columns-3_last'])}>
            <Text size="md">The last line fee</Text>
            <Text size="md" weight="demiBold">{formatMoney(calcResult.lastLineFee.value || 0)}</Text>
            <Text size="md">{calcResult.lastLineFee.notes}</Text>
          </div>
        }
        <div className={styles['flex-center']}>
        { !disableInput &&
          <Button // block
            htmlType="submit"
            loading={
              false
              // isCreateMutating || isUpdateMutating || isUpdateForecastMutating
            }
          >
            Confirm
          </Button>
        }
        </div>
      </Form>
    </>
  )
}
